// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-dropdown {
    width: 250px;

    .bolt-button {
        width: 250px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Docs/Components/Dropdown/examples/Dropdown.css"],"names":[],"mappings":"AAAA;IACI,YAAY;;IAEZ;QACI,YAAY;IAChB;AACJ","sourcesContent":[".example-dropdown {\r\n    width: 250px;\r\n\r\n    .bolt-button {\r\n        width: 250px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
